module.exports = __webpack_public_path__ + "img/TG.a6166045.png";